<kz-field [formGroup]="kazaForm">
  <label kzLabel for="kz-select-country" i18n="@@kaza.edit.geolocalisation.title" isRequired="true">Location of your project</label>
  <ng-select formControlName="country" id="kz-select-country">
    <ng-option *ngFor="let countryLoop of countries" [value]="countryLoop.code">{{ countryLoop.name}}</ng-option>
  </ng-select>
  <div *ngIf="kazaForm.get('country').invalid" kzError i18n="@@registration-create-kaza.countryMissingError">You must select a country</div>
</kz-field>
